// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"119":"e6ad440b","559":"bfa62a6f","930":"0036b4a9"}[chunkId] + ".chunk.js";
};